import $ from 'jquery';
import 'jquery-ui-autocomplete';
import { autoCompleteSearch } from './aktiv-property-search';

const initAutoComplete = (campaignId) => {
  const $container = $('#' + campaignId);
  const $aktivSearchResult = $container.find('#aktiv-search-result-' + campaignId);
  const $autoComplete = $container.find('.aktiv-ui-autocomplete-input').autocomplete({
    appendTo: $aktivSearchResult,
    source: (request, response) => {
      autoCompleteSearch(request.term).then((responses) => {
        response(responses);
      }, () => {
        response([]);
      });
    },
  });

  $autoComplete.data('ui-autocomplete')._renderItem = (ul, item) => {
    return $('<li>')
      .html(`<a href="${item.url}">${item.name}</a>`)
      .appendTo(ul);
  };
};

export { initAutoComplete };
